export default "<template>\n\n  <KLogo\n    altText=\"Kolibri logo with background\"\n    :size=\"120\"\n    :showBackground=\"true\"\n  />\n\n</template>\n";